import React, { useState, useEffect } from 'react';
import { useToast } from '../../../hooks/use-toast'; // Correct import for shadcn/ui toast
import { Button } from '../../../components/ui/button'; // Import Button
import { Input } from '../../../components/ui/input'; // Import Input
import { Badge } from '../../../components/ui/badge'; // Import Badge
import { X } from 'lucide-react'; // Import X icon for remove
import api from "../../../services/apiServices"; // adjust the path as needed

export default function AliasesTab({ category, locale }) {
  const [aliases, setAliases] = useState([]);
  const [newAlias, setNewAlias] = useState('');
  const [saving, setSaving] = useState(false);
  const { toast } = useToast(); // Initialize useToast

  console.log("Category in AliasesTab:", category);


  useEffect(() => {
  const fetchAliases = async () => {
    if (!category?.id) return;

    try {
      const response = await api.get(`/admin/categories/aliases/${category.id}`,{
        params: { locale },
      });
      setAliases(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error("Error fetching aliases:", error);
      setAliases([]);
      toast({
        variant: "destructive",
        title: "Error",
        description: "Could not fetch aliases.",
      });
    }
  };

  fetchAliases();
}, [category, toast,locale]); // Added toast to dependency array as it's used in the catch block

  const addAlias = () => {
    const trimmed = newAlias.trim();
    if (trimmed && !aliases.includes(trimmed)) {
      setAliases([...aliases, trimmed]);
      setNewAlias('');
    }
  };

  const removeAlias = (aliasToRemove) => {
    setAliases(prev => prev.filter(alias => alias !== aliasToRemove));
  };

  const saveAliases = async () => {
    setSaving(true);
    try {
      const response = await api.post(`/admin/categories/aliases/${category.id}`, {
        aliases,
      },{params: { locale },});

      const updated = response.data;
      setAliases(Array.isArray(updated) ? updated : []); // Always use an array

      toast({
        variant: "success",
        title: "Success!",
        description: "Aliases saved successfully.",
      });
    } catch (error) {
      console.error("Save Error:", error);

      const message =
        error?.response?.data?.message || error.message || "There was an issue saving the aliases.";

      toast({
        variant: "destructive",
        title: "Save Error",
        description: message,
      });
    } finally {
      setSaving(false);
    }
  };
  // Ensure category and category.id exist before rendering
  if (!category || !category.id) {
    return (
      <div className="space-y-4">
        <h2 className="text-lg font-semibold">Category Aliases</h2>
        <p className="text-sm text-gray-500">Please select a category to manage aliases.</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold">Category Aliases</h2>
      <p className="text-sm text-gray-500">Add common search terms that map to this category.</p>

      <div className="flex space-x-2">
        <Input // shadcn/ui Input component
          type="text"
          value={newAlias}
          onChange={e => setNewAlias(e.target.value)}
          onKeyDown={e => {
            if (e.key === 'Enter') {
              e.preventDefault();
              addAlias();
            }
          }}
          placeholder="Add new alias"
          className="w-full" // Tailwind class for width
        />
        <Button onClick={addAlias} variant="default"> {/* shadcn/ui Button component */}
          Add
        </Button>
      </div>

      {aliases.length > 0 && (
        <div className="mt-4 space-y-2">
          <h3 className="text-md font-medium">Current Aliases:</h3>
          <div className="flex flex-wrap gap-2">
            {aliases.map((alias, i) => (
              <Badge key={i} variant="secondary" className="flex text-md items-center"> {/* shadcn/ui Badge component */}
                {alias}
                <Button
                  variant="ghost" // Ghost variant for a less intrusive button
                  size="icon" // Icon size
                  className="ml-2 h-4 w-4 p-0" // Adjust size and padding for the icon button
                  onClick={() => removeAlias(alias)}
                >
                  <X className="h-3 w-3" /> {/* Lucide X icon */}
                </Button>
              </Badge>
            ))}
          </div>
        </div>
      )}

      <Button
        onClick={saveAliases}
        disabled={saving}
        variant="default" // Primary action button
        className="mt-4"
      >
        {saving ? 'Saving...' : 'Save Aliases'}
      </Button>
    </div>
  );
}